import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import myAxios from '../../../../lib/axios';


const initialState = {
    data: [],
};

export const fetchCv = createAsyncThunk(
    'masters/fetchCv',
    async (query) => {
        try {
            const response = await myAxios.get(`/cv/resume/all`);

            return { success: true, message: "Cvs fetched successfully!", data: response?.data?.resumes };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);





const cvSlice = createSlice({
    name: 'cv',
    initialState,
    reducers: {
        clearCvData: state => {
            state.data = [];
        },
        setCvData: (state, action) => {
            state.data = action.payload;
        },

    },
});

export const cvReducer = cvSlice.reducer;
export const { clearCvData, setCvData } = cvSlice.actions;

export const selectCvData = (state) => state.cv.data;
